import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { LOGO } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const Logo = ({ className = "h-12" }) => (
  <span className={`${className} inline-flex items-center overflow-hidden`}>
    <img
      src={LOGO}
      alt="Faith Up Athletes logo"
      className="h-full w-auto object-contain scale-[1.55]"
    />
  </span>
);

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-2xl bg-[#0A0A0A]/80 border-b border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="flex items-center">
          <Logo className="h-[68px]" />
        </Link>
        <nav className="flex items-center gap-3 sm:gap-6">
          <Link
            to="/"
            data-testid="nav-roster-link"
            className="label-mono hover:text-white transition-colors hidden sm:block"
          >
            Roster
          </Link>
          {user?.is_admin && (
            <Link
              to="/admin"
              data-testid="nav-admin-link"
              className="label-mono hover:text-[#FF5A00] transition-colors flex items-center gap-2"
            >
              <ShieldCheck size={14} /> Admin
            </Link>
          )}
          {user && (
            <button
              data-testid="nav-logout-btn"
              onClick={async () => {
                await logout();
                navigate("/");
              }}
              className="label-mono flex items-center gap-2 hover:text-[#FF5A00] transition-colors"
            >
              <LogOut size={14} /> Sign out
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};

export const Footer = () => (
  <footer className="border-t border-white/10 mt-24">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-10 py-10 flex flex-col sm:flex-row gap-4 items-center justify-between">
      <Link to="/login" data-testid="footer-admin-link" aria-label="Admin access">
        <Logo className="h-14" />
      </Link>
      <p className="label-mono">Built for recruitment · Faith · Family · Football</p>
    </div>
  </footer>
);
